
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    DEVICES_BULK_ACTIONS_SEARCH_DEVICES_REQUEST,
    DEVICES_BULK_ACTIONS_SEARCH_DEVICES_MODEL_REQUEST,
    DEVICES_BULK_ACTIONS_SEARCH_COMMANDS_REQUEST,
    DEVICES_BULK_SEND_MESSAGE_REQUEST,
    DEVICES_BULK_ACTIONS_REQUEST,
    DEVICES_BULK_ACTIONS_GET_SUPPORTED_TIMEZONES_REQUEST
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { clientGET } from 'Core/data/RestApi';
import {
    bulkActionsSearchDevicesResult,
    bulkActionsSearchDeviceModelResult,
    bulkActionsSearchCommandsResult,
    bulkActionsSendMessageResult,
    bulkActionsResult,
    bulkActionsGetSupportedTimezonesResult,
} from 'Redux/actions';


function* searchDevices({ payload }) {
    try {
        const QUERY = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        label
                        imei
                        esn
                        companyId
                        deviceModel {
                            id
                            name
                            manufacturerId
                            unitTypeId
                            manufacturer {
                                id
                                name
                            }
                            product
                            geofence
                            input
                            output
                            ota
                            sms
                            starter
                            driverBehavior
                            battery
                            analytic
                            promiles
                            comData
                            pressurePro
                            vbus
                            jbus
                            obd2Alerts
                            motion
                            tow
                            ttu
                            hoursEnable
                            odometerEnable
                            cariq
                            carbEnable
                        }
                        unitConfig {
                            unitId
                            configVersion
                            scriptVersion
                        }
                        simCard {
                            simProviderAccount {
                                id
                                name
                                simProviderId
                                simProvider {
                                    id
                                    name
                                }
                            }
                        }
                        linkedMode
                        linkedByUnit {
                            id
                            label
                        }
                    }
                    total
                }
            }
        `;

        let conditions = [];

        if (payload?.id) {
            conditions.push({
                fields: ["companyId"],
                terms: [payload?.id],
                exact: true
            })
        }
        if (payload?.manufacturer) {
            conditions.push({
                fields: ["deviceModel_manufacturer_id"],
                terms: [payload?.manufacturer],
                exact: true
            })
        }

        if (payload?.deviceModel) {
            conditions.push({
                fields: ["deviceModel_id"],
                terms: [payload?.deviceModel],
                exact: true
            })
        }

        if (payload?.simProvider) {
            conditions.push({
                fields: ["simCard_simProviderAccount_id"],
                terms: [payload?.simProvider],
                exact: true
            })
        }

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: conditions,
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data.result
            yield put(bulkActionsSearchDevicesResult(items))
        } else {
            yield put(bulkActionsSearchDevicesResult([]))
        }

    } catch (exc) {
        yield put(bulkActionsSearchDevicesResult([]))
        ExceptionManager(
            exc,
            "Modules/devices/.components/bulkActions/redux/saga",
            "searchDevices",
        )
    }
}

function* searchDeviceModels({ payload }) {
    try {
        const { name } = payload
        let QUERY = `
            query searchDeviceModels ($conditions: [DeviceModelSearchInput], $sort: [DeviceModelSortInput], $limit: Int, $offset: Int) {
                result: searchDeviceModels (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        name
                    }
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["manufacturer_name"],
                    terms: [name],
                    exact: true
                },
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        //timezones ids
        let QUERY_TIMEZONE = `
            query getTimezonesSupported {
                result: getTimezonesSupported
            }
        `

        let dataTimezone = yield call(
            clientQuery,
            QUERY_TIMEZONE,
            {},
            endpoints.GRAPHQL_GENERAL,
        );

        let timezones = [];
        if (dataTimezone.result) {
            try {
                let resultTimezones = JSON.parse(dataTimezone.result)
                if (resultTimezones.length > 0) {
                    resultTimezones.map((tz, index) => {
                        timezones.push({ id: tz, label: tz });
                    })
                }
            } catch (error) { }
        }

        if (data?.result) {
            const { items } = data.result;
            yield put(bulkActionsSearchDeviceModelResult({ items, timezones }))
        } else {
            yield put(bulkActionsSearchDeviceModelResult([]))
        }

    } catch (exc) {
        yield put(bulkActionsSearchDeviceModelResult([]))
        ExceptionManager(
            exc,
            "Modules/devices/.components/bulkActions/redux/saga",
            "searchDeviceModels",
        )
    }
}

function* getSupportedTimezones({ payload }) {
    try {
        

        let QUERY_TIMEZONE = `
            query getTimezonesSupported {
                result: getTimezonesSupported
            }
        `
        let dataTimezone = yield call(
            clientQuery,
            QUERY_TIMEZONE,
            {},
            endpoints.GRAPHQL_GENERAL,
        );

        let timezones = [];
        if (dataTimezone.result) {
            try {
                let resultTimezones = JSON.parse(dataTimezone.result)
                if (resultTimezones.length > 0) {
                    resultTimezones.map((tz, index) => {
                        timezones.push({ id: tz, label: tz });
                    })
                }
            } catch (error) { }
        }
        yield put(bulkActionsGetSupportedTimezonesResult(timezones))

    } catch (exc) {
        yield put(bulkActionsSearchbulkActionsGetSupportedTimezonesResultDeviceModelResult([]))
        ExceptionManager(
            exc,
            "Modules/devices/.components/bulkActions/redux/saga",
            "getSupportedTimezones",
        )
    }
}

function* updateUnits({ payload }) {
    try {
        let QUERY = `
            mutation updateUnitsBatch ($unitIds: [Int]!, $features: UnitFeatureInput!, $simProviderAccountId: Int, $timezoneId: Int, $liveMode: enumLiveMode, $tagIds: [Int]) {
                result: updateUnitsBatch (unitIds: $unitIds, features: $features, simProviderAccountId: $simProviderAccountId, timezoneId: $timezoneId, liveMode: $liveMode, tagIds: $tagIds){
                    stepFunctionId
                    transactionId
                    transactionType
                    processStartDate
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(bulkActionsResult({ updateFeatures: data?.result }))
        } else yield put(bulkActionsResult({ updateFeatures: false }))


    } catch (exc) {
        yield put(bulkActionsResult({ updateFeatures: false }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/bulkActions/redux/saga",
            "updateUnits",
        )
    }
}

function* searchCannedCommands({ payload }) {
    try {
        const manufacturerId = payload?.manufacturerId;
        const unitTypeIds = (payload?.unitTypeIds || []).filter((item, index, arr) => item && arr.indexOf(item) === index);
        const deviceModels = payload?.deviceModels || [];
        const via = payload?.via || "SMS";

        if (!manufacturerId) {
            yield put(bulkActionsSearchCommandsResult({ manufacturer: null, unitTypes: [], deviceModels: [] }))
            return;
        }

        let QUERY = `
            query searchCannedCommands ($conditions: [CannedCommandSearchInput], $sort: [CannedCommandSortInput], $limit: Int, $offset: Int) {
                result: searchCannedCommands (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        unitTypeId
                        unitType {
                            id
                            name
                            manufacturerId
                            manufacturer {
                                id
                                name
                            }
                            dbSchema
                            active
                        }
                        via
                        label
                        command
                        status
                        appliesToAllUnitTypes
                    }
                    total
                }
            }
        `;
        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["manufacturerId"],
                        terms: [manufacturerId],
                        exact: true
                    },
                    {
                        fields: ["via"],
                        terms: [via],
                        exact: true
                    }
                ],
                limit: 600,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data.result;
            const manufacturerCommands = items.filter(x => x.appliesToAllUnitTypes || !x.unitTypeId);
            const unitTypeGroups = unitTypeIds.map((unitTypeId) => {
                const cannedCommands = items.filter(x => x.appliesToAllUnitTypes || x.unitTypeId === unitTypeId);
                const unitTypeName = cannedCommands.find(x => x.unitType?.id === unitTypeId)?.unitType?.name || `Unit Type #${unitTypeId}`;
                return {
                    entity: "UnitType",
                    entityId: unitTypeId,
                    entityLabel: unitTypeName,
                    cannedCommands
                };
            });

            const deviceModelGroups = deviceModels.map((deviceModel) => {
                const cannedCommands = items.filter(x => x.appliesToAllUnitTypes || x.unitTypeId === deviceModel.unitTypeId);
                return {
                    entity: "DeviceModel",
                    entityId: deviceModel.id,
                    entityLabel: deviceModel.name,
                    unitTypeId: deviceModel.unitTypeId,
                    cannedCommands
                };
            });

            const payloadResult = {
                manufacturer: {
                    entity: "Manufacturer",
                    entityId: manufacturerId,
                    entityLabel: payload?.manufacturerName || "Manufacturer",
                    cannedCommands: manufacturerCommands
                },
                unitTypes: unitTypeGroups,
                deviceModels: deviceModelGroups
            };

            yield put(bulkActionsSearchCommandsResult(payloadResult))
        } else {
            yield put(bulkActionsSearchCommandsResult({ manufacturer: null, unitTypes: [], deviceModels: [] }))
        }

    } catch (exc) {
        yield put(bulkActionsSearchCommandsResult({ manufacturer: null, unitTypes: [], deviceModels: [] }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/bulkActions/redux/saga",
            "searchCannedCommands",
        )
    }
}

function* createNotification({ payload }) {
    try {

        let QUERY = `
            mutation createNotification ($email: emailNotificationInput, $sms: String, $command: String, $to: [toEntityInput]!, $emailRecipients: [String]) {
                result: createNotification (email: $email, sms: $sms, command: $command, to: $to, emailRecipients: $emailRecipients)
            }
        `;
        const requests = Array.isArray(payload) ? payload : [payload];
        let successCount = 0;

        for (const requestPayload of requests) {
            let data = yield call(
                clientMutation,
                QUERY,
                requestPayload,
                endpoints.GRAPHQL_GENERAL,
            );

            if (data?.result) {
                successCount += 1;
            }
        }

        if (successCount > 0) {
            yield put(bulkActionsSendMessageResult({ success: true, successCount, total: requests.length, error: successCount !== requests.length }))
        } else {
            yield put(bulkActionsSendMessageResult({ success: false, error: true, successCount: 0, total: requests.length }))
        }

    } catch (exc) {
        yield put(bulkActionsSendMessageResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/bulkActions/redux/saga",
            "createNotification",
        )
    }
}


function* watchMethods() {
    yield takeEvery(DEVICES_BULK_ACTIONS_SEARCH_DEVICES_REQUEST, searchDevices);
    yield takeEvery(DEVICES_BULK_ACTIONS_SEARCH_DEVICES_MODEL_REQUEST, searchDeviceModels);
    yield takeEvery(DEVICES_BULK_ACTIONS_REQUEST, updateUnits);
    yield takeEvery(DEVICES_BULK_ACTIONS_SEARCH_COMMANDS_REQUEST, searchCannedCommands);
    yield takeEvery(DEVICES_BULK_SEND_MESSAGE_REQUEST, createNotification);
    yield takeEvery(DEVICES_BULK_ACTIONS_GET_SUPPORTED_TIMEZONES_REQUEST, getSupportedTimezones);
    
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}